<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent: 00em;">NG Rippel’s interest in writing was driven by a misguided impression that his great-uncle was writing deep thoughts into the small Scripto notepad which was kept in his front shirt pocket. At age of six, Rippel started doing the same, and continued the practice, despite learning that what Uncle George was writing were lines of information on upcoming weddings and funerals where he might be able to pick up a free meal. However, Rippel has continued the practice of writing lines in notepads for the past 65+ years.</p><br/>
<p style="text-indent: 00em;">NG Rippel began writing words and being an observer of whatever surrounded him. At the age of 25, he became a realist and dedicated himself to increasing his understanding of reality. An effort which has continued ever since.</p>
<p style="text-indent: 00em;">To learn more about NG Rippel, go to ngrippel.com.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2eb3fc1a